import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { Form, FormGroup, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import SvgImage from "../../../Icons/Icons";
import { DatePickerField } from "../../../core/inputs/input";
import moment from "moment";
import { Button } from "reactstrap";
import Switch from "react-switch";
import { getSignedUrlApiAction, storeMedia, toastStatus } from "../../../../services/Store/Actions/appActions";
import ImageModal from "../../imageModal";
import AddEditDocModal from "../addEditDocModal";

function PermitItems(props) {
    const dispatch = useDispatch();

    const { type,value ,data, fleetId, vehicleData} = props
    console.log("keyvaluedata PermitItems",type, value ,data, vehicleData);

    const [update, setUpdate] = useState(false);
    const closeUpdate = () => {
        setUpdate(false);
    };
    const toggleUpdate = () => {
        setUpdate(!update);
    }
    const [imageModal, setImageModal] = useState(false);
    const closeImageModal = () => {
        setImageModal(false);
    };
    const toggleImageModal = () => {
        setImageModal(!imageModal);
    }

    
    const [imageUrl, setImageUrl] = useState('');
    const [rawImage, setRawImage] = useState(data?.imageUrl || '')

    useEffect(() => {
        if(rawImage && !imageUrl){
            dispatch(
                getSignedUrlApiAction(
                  { key: rawImage},
                  (res) => {
                    // setDownloadLoader2(false);
                    // setLoaderInvoiceId("");
                    if (res.status == 200) {
                        console.log("getSignedUrlApiAction",value,res?.data?.data);
                        setImageUrl(res?.data?.data)
                    }
                  }
                )
              );
        }
    },[rawImage])
    const printDocument = () => {
        window.open(imageUrl);
    }
    const boxShadow = (date) => {
        console.log("typeboxShadowboxShadowboxShadow", date);
        let a = { }
        if(Date.parse(date) - Date.now() < 15*24*60*60*1000){
            a.boxShadow = "0 2px 4px 0 rgb(255, 0, 0,1), 0 1.5px 5px 0 rgba(255, 0, 0, 0.98)" 
        }
        else if(Date.parse(date) - Date.now() < 30*24*60*60*1000 ) {
            a.boxShadow = "0 2px 4px 0 rgb(255, 150, 0,1), 0 1.5px 5px 0 rgba(255, 150, 0, 0.98)" 
        }else{
            a.boxShadow = "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" 
        }
        console.log("typeboxShadowboxShadowboxShadow",a);
        return a 
    }
    const styleTemp = boxShadow(data?.expiryDate);
    return  (<div>
            <div className="divClass1 imageBox" style={{height: "200px", ...styleTemp}}>
                <div className="col-8" style={{ width: "50%",paddingTop: "20px"}}>
                   <div style={{display: "flex", flexDirection:"row", justifyContent:"space-between"}}>
                        <div className=" heading2 semiBold">
                            {value}
                        </div>
                        <div className="divClass1" style={{ justifyContent: "end" }} >
                            {imageUrl ? <div onClick={printDocument} style={{ paddingRight: "5px" }}>
                                <SvgImage name="downloadImg" width="24" height="24" />
                            </div>: <></>}
                            <div onClick={() => setUpdate(true)}>
                            <SvgImage name="editLogo" width="25" height="25" />
                            </div>
                        </div>
                   </div>
                    { (<div style={{marginTop:"50px"}}>
                        <div className="divClass1">
                            <div>Doc Number</div><div>{data?.tagId}</div>
                        </div>
                        <div className="divClass1">
                            <div>Registration Date</div><div>{data?.serviceDate}</div>
                        </div>
                        <div className="divClass1">
                            <div>Expiry Date</div><div>{data?.expiryDate}</div>
                        </div>
                    </div>) 
                }
                </div>
                <div className="col-4 " style={{ 
                }}>{imageUrl ? ( 
                <div className="documentBox" onClick={()=>{ setImageModal(true)}}>
                    <img 
                        src={imageUrl.split('?')[0]}
                        alt={value}
                        width="100%" 
                        height="185px"
                    />
                </div>): <></>
            }
                   
                </div>
            </div>
            {imageModal ? (
          <ImageModal
            toggle={toggleImageModal}
            imageModal={imageModal}
            setImageModal={setImageModal}
            image={imageUrl.split('?')[0]}
           
          />
        ) : <></>}
        {update ? <AddEditDocModal 
            toggle={toggleUpdate} 
            modal={update}
            setModal={setUpdate} 
            isEdit={true} 
            fleetId={fleetId}
            type={111}
            data={data}
            value={value}
            rawImage={rawImage}
            setRawImage={setRawImage}
        /> : <></>}
        
            </div> )
}
export default PermitItems;




